/**
 * Shared CSV Schema Constants
 *
 * These constants define the standard column names used in CSV transformations
 * for rebate invoices and other data import workflows.
 */

/**
 * Standard column names for rebate invoice CSV files
 */
export const REBATE_CSV_COLUMNS = {
  DATE: "Date",
  DIVISION_NAME: "Division Name",
  PRODUCT_GROUP_NAME: "Product Group Name",
  VALUE: "Value",
  SUPPLIER_NAME: "Supplier Name",
  CURRENCY: "Currency",
} as const;

/**
 * Array of required columns for rebate invoice CSV validation
 * Note: All columns listed must be present in the CSV header.
 * Product Group Name can have empty/null/"All Products" to mean all products.
 */
export const REQUIRED_REBATE_CSV_COLUMNS = [
  REBATE_CSV_COLUMNS.DATE,
  REBATE_CSV_COLUMNS.DIVISION_NAME,
  REBATE_CSV_COLUMNS.PRODUCT_GROUP_NAME, // Column is required, but value can be empty/"All Products"
  REBATE_CSV_COLUMNS.VALUE,
] as const;

/**
 * Type for rebate CSV column names
 */
export type RebateCsvColumn =
  (typeof REBATE_CSV_COLUMNS)[keyof typeof REBATE_CSV_COLUMNS];

/**
 * Analysis result for CSV migration compatibility
 */
export interface CsvAnalysis {
  invoiceId: string;
  invoiceNumber: string;
  canMigrate: boolean;
  status: "compatible" | "compatible_with_notice" | "incompatible";
  lineItemCount: number;
  warnings: string[];
  blockers: string[];
}

/**
 * Compatibility report for CSV migration between rebate agreement versions
 */
export interface MigrationCompatibilityReport {
  compatible: boolean;
  csvAnalysis: CsvAnalysis[];
}
